import { billingAndShippingAddressStyles as styles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/BillingAndShippingInfo";

styles.carrierGridItem = {
    ...styles.carrierGridItem,
    width: 6,
};

styles.shippingServiceGridItem = {
    ...styles.shippingServiceGridItem,
    width: 0,
};
